const getters = {
    //登录状态
    isLogin: state => state.app.isLogin,
    token: state => state.app.token,
    userinfo: state=> state.user.userInfo,
    setPayPass: state => state.app.setPayPass,
    address: state => state.user.address,
    postAppraises: state=> state.user.postAppraises,
    orderNum: state=> state.shop.orderNum,
    orderScoreDetail: state=>state.user.orderScoreDetail,
    scoreExchangeId: state=>state.user.scoreExchangeId,
    confirmGoods: state => state.shop.confirmGoods,
    paySuccOrderId: state => state.shop.paySuccOrderId
}
export default getters




// WEBPACK FOOTER //
// ./src/store/getters.js